import { Error } from "@/components/admin/error";
import { Notification } from "@/components/admin/notification";
import { Skeleton } from "@/components/ui/skeleton";
import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { DataImportProvider } from "../dataImport/DataImportProvider";
import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { MobileNavigation } from "./MobileNavigation";
import { PullToRefresh } from "./PullToRefresh";
import { OnboardingProvider, OnboardingStory } from "../onboarding";
import { AccountLocaleSync } from "../projects/LocaleSelector";
import { AccountCurrencySync } from "../projects/CurrencySelector";

export const MobileLayout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  return (
    <DataImportProvider>
      <OnboardingProvider>
        <AccountLocaleSync />
        <AccountCurrencySync />
        <PullToRefresh />
        <ErrorBoundary FallbackComponent={Error}>
          <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
            {children}
          </Suspense>
        </ErrorBoundary>
        <OnboardingStory />
        <MobileNavigation />
        <Notification mobileOffset={{ bottom: "72px" }} />
      </OnboardingProvider>
    </DataImportProvider>
  );
};
